import React from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import indexannouncementicon from "../assets/images/news.webp";

const fallbackCopy =
  "🎉🎉🎉CK75.live আনুষ্ঠানিকভাবে একটি কৌশলগত ব্র্যান্ড পার্টনারশিপে যুক্ত হয়েছে! 🎆🎆🎆     🌈🌈🌈নতুন বছরের স্বপ্নের পরিকল্পনা আনুষ্ঠানিকভাবে চালু হয়েছে! 🎉🎉🎉";

const CurrentNews = ({ message }) => {
  const navigate = useNavigate();
  const downloadBar = useContextSelector(AuthContext, (ctx) => ctx.downloadBar);
  const text =
    message?.length > 0
      ? message.map((item) => item?.message).filter(Boolean).join("     ")
      : fallbackCopy;

  return (
    <button
      type="button"
      className={
        downloadBar
          ? "marquee-notification notice-root"
          : "marquee-notification notice-root"
      }
      onClick={() => navigate("/notice")}
    >
      <div className="notice-bg">
        <div className="notice-icon">
          <img src={indexannouncementicon} alt="" />
        </div>
        <div className="ck-marquee">
          <div className="ck-marquee-track">
            <span>{text}</span>
            <span>{text}</span>
          </div>
        </div>
      </div>
    </button>
  );
};

export default CurrentNews;
